import React, {PureComponent} from 'react';

/**
 * Component for including a crosshatch pattern to be used as a fill
 * on a generated svg graphic.
 *
 * This pattern only needs to be included once per page for other svg elements
 * to be able to use it as a fill.
 *
 * @example
 * <svg>
 *   <PatternCrosshatch/>
 *   <path fill="url(#crosshatch)" d="..."/>
 * </svg>
 */
export default class PatternCrosshatch extends PureComponent {
  render() {
    return (
      <svg height="8" width="8" xmlns="http://www.w3.org/2000/svg" version="1.1">
        <defs>
          <pattern id="crosshatch" patternUnits="userSpaceOnUse" width="8" height="8">
            <image xlinkHref="data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPSc4JyBoZWlnaHQ9JzgnPgogIDxyZWN0IHdpZHRoPSc4JyBoZWlnaHQ9JzgnIGZpbGw9JyNmZmYnLz4KICA8cGF0aCBkPSdNMCAwTDggOFpNOCAwTDAgOFonIHN0cm9rZS13aWR0aD0nMC41JyBzdHJva2U9JyM2RjZGNkYnLz4KPC9zdmc+Cg==" x="0" y="0" width="8" height="8"/>
          </pattern>
        </defs>
      </svg>
    )
  }
}
